// Rule Set tab value that shows premades from every ruleset
export const ALL_RULESETS = "All";

export type RulesetSelection = number | typeof ALL_RULESETS;

// Ruleset ids in the order the Rule Set tabs and Collection groups show them.
// Rulesets not listed here sort after these.
// eventually we should use ruleset display order instead of ids
export const RULESET_ORDER: Array<number> = [
  1, // 5.5e
  2, // 5e
];
